export default function IconGym() {
  return (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      aria-hidden="true"
    >
      <rect x="46" y="17" width="8" height="30" rx="2" />
      <rect x="21" y="29" width="22" height="6" />
      <rect x="56" y="23" width="4" height="18" rx="1.5" />
      <rect x="10" y="17" width="8" height="30" rx="2" />
      <rect x="4" y="23" width="4" height="18" rx="1.5" />
    </svg>
  );
}
